import type { Duration } from 'date-fns'
import type { Locale } from 'date-fns'
import { formatDuration } from 'date-fns/formatDuration'
import { de } from 'date-fns/locale/de'
import { enGB } from 'date-fns/locale/en-GB'
import i18n from 'i18next'

export const secondsToTimeObject = (totalSeconds: number) => {
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)

  return { hours, minutes }
}

const locales: Record<string, Locale> = {
  de: {
    ...de,
    formatDistance: (token, count) => {
      const shortTokens: Record<string, string> = {
        xHours: count > 0 ? `${count} h` : '',
        xMinutes: `${count} min`,
      }
      return shortTokens[token] || ''
    },
  },
  en: {
    ...enGB,
    formatDistance: (token, count) => {
      const shortTokens: Record<string, string> = {
        xHours: count > 0 ? `${count} h` : '',
        xMinutes: `${count} min`,
      }
      return shortTokens[token] || ''
    },
  },
}
export const defaultOptions = () => ({
  locale: locales[i18n.language],
  zero: true,
})

export const formatReportDuration = (duration: Duration): string =>
  formatDuration(duration, {
    ...defaultOptions(),
    format: ['hours', 'minutes'],
  })
